import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, vModelText as _vModelText, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["list", "placeholder", "title"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["selected", "value"]
const _hoisted_5 = ["disabled", "title"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["label"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["name"]
const _hoisted_11 = ["disabled", "title"]
const _hoisted_12 = ["label"]
const _hoisted_13 = ["value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.show_second ? 'input-group' : '')
  }, [
    ($props.datalist)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          ref: "datalist",
          class: "form-control",
          list: $data.uuid,
          placeholder: $options.drop_emoji($options.placeholder),
          title: $options.placeholder,
          type: "text",
          onChange: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.datalist_select && $options.datalist_select(...args)), ["stop","prevent"]))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    ($props.datalist)
      ? (_openBlock(), _createElementBlock("datalist", {
          key: 1,
          id: $data.uuid
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (value, pk) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: pk }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (value, label) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: label }, [
                  _createElementVNode("option", {
                    readonly: "",
                    value: label
                  }, null, 8 /* PROPS */, _hoisted_3),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (value, pk) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: pk,
                      selected: pk == $data.current,
                      value: value
                    }, null, 8 /* PROPS */, _hoisted_4))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ], 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($options.selection) = $event)),
      class: _normalizeClass(["form-select prevent-submit-onchange", {
                'is-invalid': $options.is_invalid,
                'flex-grow-0': $options.show_second && $props.size_1
            }]),
      disabled: $props.disabled,
      style: _normalizeStyle({
                width: $options.show_second ? $props.size_1 : null
            }),
      title: $options.label
    }, [
      ($options.is_invalid)
        ? (_openBlock(), _createElementBlock("option", {
            key: 0,
            value: $options.selection
          }, _toDisplayString($props.value), 9 /* TEXT, PROPS */, _hoisted_6))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (inner, label) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: label }, [
          label
            ? (_openBlock(), _createElementBlock("optgroup", {
                key: 0,
                label: label
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inner, (_, opt) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: $options.make_key(label, opt),
                    value: $options.make_key(label, opt)
                  }, _toDisplayString(opt), 9 /* TEXT, PROPS */, _hoisted_8))
                }), 128 /* KEYED_FRAGMENT */))
              ], 8 /* PROPS */, _hoisted_7))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(inner, (_, opt) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: $options.make_key(label, opt),
                  value: $options.make_key(label, opt)
                }, _toDisplayString(opt), 9 /* TEXT, PROPS */, _hoisted_9))
              }), 128 /* KEYED_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */))
    ], 14 /* CLASS, STYLE, PROPS */, _hoisted_5), [
      [_vModelSelect, $options.selection]
    ]),
    _withDirectives(_createElementVNode("input", {
      ref: "hidden",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.current) = $event)),
      name: $props.name,
      type: "hidden"
    }, null, 8 /* PROPS */, _hoisted_10), [
      [_vModelText, $data.current]
    ]),
    ($options.show_second)
      ? _withDirectives((_openBlock(), _createElementBlock("select", {
          key: 2,
          ref: "second",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.current) = $event)),
          class: _normalizeClass(["form-select prevent-submit-onchange", {
                'flex-grow-0': $props.size_2
            }]),
          disabled: $props.disabled || $options.length($options.options_visible) <= 1,
          style: _normalizeStyle({
                width: $props.size_2
            }),
          title: $options.placeholder
        }, [
          _createElementVNode("optgroup", { label: $options.label }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.options_visible, (title, pk) => {
              return (_openBlock(), _createElementBlock("option", {
                key: pk,
                value: pk
              }, _toDisplayString(title), 9 /* TEXT, PROPS */, _hoisted_13))
            }), 128 /* KEYED_FRAGMENT */))
          ], 8 /* PROPS */, _hoisted_12)
        ], 14 /* CLASS, STYLE, PROPS */, _hoisted_11)), [
          [_vModelSelect, $data.current]
        ])
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "buttons")
  ], 2 /* CLASS */))
}